<div class="row">
  <div class="col">
    <c11n-internal-callout [variant]="direction"
                           class="c11n-internal-callout mb-md-5 mb-5"
                           [headingLevel]="6">
      <span class="c11n-text-md-bold">{{ message }}</span>

    </c11n-internal-callout>
  </div>
</div>

